module.exports = __webpack_public_path__ + "img/objective-4@2x.523996d6.jpg";